






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from './EStatusType'
import { EClaimTaskStatus } from '@zunta/configurations'
import { CLAIM_TASK_STATUS_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusClaimTask extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    switch (this.$props.status) {
      case EClaimTaskStatus.COMPLETED:
        return EStatusType.success
      case EClaimTaskStatus.OPENED:
        return EStatusType.process
      case EClaimTaskStatus.INCORRECT:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return CLAIM_TASK_STATUS_LABEL_MAP[this.$props.status]
  }
}
